module.exports = __webpack_public_path__ + "fonts/Alata-Regular.ttf!static";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Alata-Regular.ttf
// module id = 43
// module chunks = 0